import { useState, createContext } from 'react';

import 'styles/Modals.css';

export function useDialogState() {
  const [visible, setVisible] = useState(false);
  const [view, setView] = useState('initial');

  return {visible, setVisible, view, setView}
};

export const DialogBoxContext = createContext(null);

export function DialogBox({dialogState, children}) {

  return (
    <div className="dialog-backdrop" style={{display: dialogState.visible ? null : 'none'}}>
      <div className="dialog-content">
        <div className="close-button" onClick={()=>{dialogState.setVisible(false); dialogState.setView(null)}}/>
        <DialogBoxContext.Provider value={dialogState}>
          {children}
        </DialogBoxContext.Provider>
      </div>
    </div>
  )
}